<agr-page-sidesheet
  [pageTitle]="title | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'createTemplate' | translate"
  (primaryAction)="createTemplate()"
>
  <app-template-filter
    sidesheet
    (update)="updateFilter($event)"
    (filterEnabled)="setFilterEnabled($event)"
  >
  </app-template-filter>

  <ng-container actions>
    <mat-form-field class="spacing--margin-right text--body">
      <mat-select [formControl]="yearControl" data-test="overview-cropYear">
        @for (year of availableCropYears$ | async; track year) {
          <mat-option [value]="year" data-test="overview-cropYear-options">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showCopyTemplatesByYear) {
      <button
        (click)="copyTemplatesByYear()"
        mat-button
        data-test="template-copy-templates-by-year"
      >
        <mat-icon>file_copy</mat-icon> {{ 'copyTemplatesByYear' | translate }}
      </button>
    }
    @if (isMobile$ | async) {
      <button mat-icon-button (click)="setSearch()" data-test="template-filter">
        <mat-icon>search</mat-icon>
      </button>
    }
  </ng-container>

  <div class="container">
    <agr-notification-empty
      [isEmpty]="!dataAvailable"
      [emptyDescription]="'templatesEmpty' | translate"
      emptyActionIcon="clear"
      [emptyActionText]="'resetFilter' | translate"
      [showEmptyAction]="filterEnabled"
      (emptyAction)="resetFilter()"
    >
      <mat-table [dataSource]="dataSource" data-test="template-table">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>{{ 'id' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem">{{ filterItem.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="isCorrupt">
          <mat-header-cell *matHeaderCellDef class="flex__child"
            >{{ 'corrupt' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child">
            @if (filterItem.isCorrupt) {
              <mat-icon class="is-corrupt">warning</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="templateType">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2">{{
            'treatmentType' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child flex__child-2">{{
            filterItem.templateType | translate
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="crop">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-3">{{
            'crop' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child flex__child-3">{{
            filterItem.cropName
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="soilType">
          <mat-header-cell *matHeaderCellDef class="flex__child">{{
            'soilType' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child">{{
            !filterItem.soilTypeId ? ('independent' | translate) : filterItem.soilTypeName
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="province">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2">{{
            'province' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child flex__child-2">{{
            filterItem.province
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="isSkal">
          <mat-header-cell *matHeaderCellDef class="flex__child">{{
            'skal' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child">
            @if (filterItem.isSkal) {
              <mat-icon>check</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isPlanetProof">
          <mat-header-cell *matHeaderCellDef class="flex__child">{{
            'planetProof' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child">
            @if (filterItem.isPlanetProof) {
              <mat-icon>check</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isGroundWaterPreservation">
          <mat-header-cell *matHeaderCellDef class="flex__child"
            >{{ 'groundWaterPreservation' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let filterItem" class="flex__child">
            @if (filterItem.isGroundWaterPreservation) {
              <mat-icon>check</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2"></mat-header-cell>
          <mat-cell
            *matCellDef="let filterItem"
            class="flex--justify-end flex__child flex__child-2"
          >
            <agr-responsive-actions
              [items]="templateActions"
              [showLabels]="false"
              (action)="templateAction($event, filterItem.id)"
            ></agr-responsive-actions>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" data-test="template-row"></mat-row>
      </mat-table>

      <mat-paginator
        #paginator
        [pageSize]="defaultPageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPage()"
        [length]="totalNumberOfItems$ | async"
      ></mat-paginator>
    </agr-notification-empty>
  </div>
</agr-page-sidesheet>
